/* eslint-disable max-len */
import {getValorConfiguracionByClave} from '@/api/services/configuracion/configuracion.api';
import {getListUnidadByUsuarioId} from '@/api/services/unidad/unidad.api';
import {postAddConfiguracionUsuario} from '@/api/services/configuracion-usuario/configuracion-usuario.api';
import {getVersion} from '@/api/services/version/version.api';
import {getListUsuarioByUnidadId} from '@/api/services/usuario/usuario.api';
import {getListAvisosActivos} from '@/api/services/avisos/avisos.api';
import {getConfigureAudit} from '@/api/services/comun/comun.api';

async function getLoaderUnidadYArea(_unidadId) {
  return Promise.all([
    getListUnidadByUsuarioId(),
    getVersion(),
  ]);
}

async function getLoaderUnidad() {
  return Promise.all([
    getListUnidadByUsuarioId(),
    getVersion(),
  ]);
}

export {
  getVersion,
  getValorConfiguracionByClave,
  postAddConfiguracionUsuario,
  getLoaderUnidadYArea,
  getLoaderUnidad,
  getListAvisosActivos,
  getListUsuarioByUnidadId,
  getConfigureAudit,
};
